(() => {
  const storageKey = 'ryugear-collection-view';
  const validModes = new Set(['grid', 'list']);

  const readMode = () => {
    try {
      const savedMode = window.localStorage.getItem(storageKey);
      return validModes.has(savedMode) ? savedMode : 'grid';
    } catch (_error) {
      return 'grid';
    }
  };

  const saveMode = (mode) => {
    try {
      window.localStorage.setItem(storageKey, mode);
    } catch (_error) {

    }
  };

  const initializeCollectionView = (root) => {
    if (!root || root.dataset.ryuCollectionViewReady === 'true') return;
    root.dataset.ryuCollectionViewReady = 'true';
    let mode = readMode();

    const applyMode = (nextMode, persist = false) => {
      mode = validModes.has(nextMode) ? nextMode : 'grid';
      root.dataset.ryuCollectionView = mode;

      const grid = root.querySelector('[data-ryu-product-grid]');
      if (grid) grid.dataset.viewMode = mode;

      root.querySelectorAll('[data-ryu-view-mode]').forEach((button) => {
        const active = button.dataset.ryuViewMode === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (persist) saveMode(mode);
    };

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ryu-view-mode]');
      if (!button || !root.contains(button)) return;
      applyMode(button.dataset.ryuViewMode, true);
    });

    const productGridContainer = root.querySelector('#ProductGridContainer');
    if (productGridContainer) {
      new MutationObserver(() => applyMode(mode)).observe(productGridContainer, { childList: true, subtree: false });
    }

    applyMode(mode);
  };

  const initializeCollectionViews = () => {
    document.querySelectorAll('[data-ryu-collection-view-root]').forEach(initializeCollectionView);
  };

  document.addEventListener('DOMContentLoaded', initializeCollectionViews);
  document.addEventListener('shopify:section:load', initializeCollectionViews);
})();
